import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useAppSelector } from '@lib/index';

const IntercomWatcher = () => {
  const { currentUser } = useAppSelector((state) => state.account);

  useEffect(() => {
    if (currentUser?.userId) {
      Sentry.setUser({ id: currentUser.userId });
    }
  }, [currentUser?.userId]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const intercomButton = document.querySelector('.intercom-launcher');
      if (!intercomButton) {
        Sentry.captureMessage('Intercom button not rendered after 5 seconds', {
          level: 'warning',
          tags: { feature: 'intercom' },
        });
      }
    }, 5000);

    return () => clearTimeout(timeout);
  }, []);

  return null;
};

export default IntercomWatcher;
